import * as R from 'ramda';
import React, { useCallback, useEffect, useState } from 'react';
// helpers/constants
import * as G from '../../../helpers';
// utilities
import { sendRequest } from '../../../utilities/http';
import endpointsMap from '../../../utilities/endpoints';
//////////////////////////////////////////////////

const useAsyncLoadChatMessages = (props) => {
  const [asyncChatMessages, setAsyncChatMessages] = useState(null);

  const getLoadChatMessagesRequest = useCallback(async (props) => {
    const { loadGuid, loadType } = props;

    const params = { loadGuid };

    const endpoint = G.ifElse(
      G.isLoadTypeClo(loadType),
      endpointsMap.cloChatMessageList,
      endpointsMap.telChatMessageList,
    );

    const res = await sendRequest('get', endpoint, { params });

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      setAsyncChatMessages(R.or(R.reverse(data), []));
    } else {
      G.handleFailResponseSimple(
        res,
        false,
        'withAsyncLoadChatMessages -> getLoadChatMessagesRequest',
      );
    }
  }, []);

  useEffect(() => {
    getLoadChatMessagesRequest(props);
  }, []);

  return { asyncChatMessages, getLoadChatMessagesRequest };
};

export const withAsyncLoadChatMessages = (Component) => (props) => {
  const { loadGuid, loadType } = props;

  const { asyncChatMessages, getLoadChatMessagesRequest } = useAsyncLoadChatMessages({
    loadGuid,
    loadType,
  });

  return (
    <Component
      {...props}
      asyncChatMessages={asyncChatMessages}
      getLoadChatMessagesRequest={getLoadChatMessagesRequest}
    />
  );
};
